module.exports = __webpack_public_path__ + "static/media/Artwork2.9298deee.jpg";